'use strict';

import 'moment'

export class CvService {
    static getPatientName(service) {
        let result = '';
        if (service.patient && service.patient.user_info) {
            const info = service.patient.user_info;
            result = info.name;
        }
        if (!result && service.request) {
            if (service.request.last_name) result += service.request.last_name;
            if (service.request.first_name) result += `, ${service.request.first_name}`;
        }
        return result;
    }
    static getPatientBasePhone(service) {
        let result = '';
        if (service.patient && service.patient.user_info) {
            const info = service.patient.user_info;
            if (Array.isArray(info.phones) && info.phones.length > 0) result = info.phones[0];
        }
        if (!result && service.request && service.request.phone) result = service.request.phone;
        return result;
    }
    static getPhysicianName(service) {
        if (!service.request) return '';

        let doc = service.request.doctor_first_name || '';
        if (service.request.doctor_last_name) doc += ` ${service.request.doctor_last_name}`;
        return doc;
    }
    static getServiceName(service) {
        const pn = this.getPatientName(service);
        const pp = this.getPatientBasePhone(service);
        const dn = this.getPhysicianName(service);
        return service.request ? `${pn} - ${pp} - ${dn}`.replace(/^[ -]+|[ -]+$/g, '') : '';
    }
    static getServiceNameOrNotes(service) {
        return (this.getServiceName(service) || service.name || '').replace(/^[ -]+|[ -]+$/g, '');
    }
    static getServiceNameId(service) {
        return this.getServiceName(service) + ` (#${service.id})`;
    }
    static getServiceDocuments(service) {
        const ndocs = Array.isArray(service.documents) ? service.documents.length : 0;
        if (ndocs < 1) return '';

        let result = '<span>';
        for (let i = 0; i < ndocs; ++i) {
            result += `<span data-toggle="tooltip" data-placement="top" title="${service.documents[i].source_name}">`
                + `<a href="/document/${service.documents[i].id}/download" class="padding-left-10">${i + 1}</a></span>`;
        }
        return `${result}</span>`;
    }
    static getServiceStatus(service) {
        const now = moment.utc();
        const ss = moment.utc(service.starts_at);
        if (now < ss || ('activated' in service && !service.activated)) return 'Waiting';

        let ndocs = 0;  // total
        let udocs = 0;  // urgent
        let ddocs = 0;  // 24-H or 48-H
        if (Array.isArray(service.documents)) {
            service.documents.forEach((v) => {
                ++ndocs;
                if (/URGENT/i.test(v.source_name)) ++udocs;
                if (/(24-H|48-H)/i.test(v.source_name)) ++ddocs;
            });
        }
        let fdocs = ndocs - udocs - ddocs;  // final
        const se = moment.utc(service.finishes_at);
        if (now > se) {
            let fc = (ddocs > 0 || fdocs > 0) ? 'ED9509' : 'FF0000';  // yellow | red
            if (service.request && (fdocs > 0 || ddocs > 0)) {
                if (!service.request.extended_type || (ddocs > 0 && fdocs > 0)) fc = '05D62E'; // green
            }
            return `<span style="color:#${fc}">Completed</span>`;
        }
        if (service.request) {
            let primary = 'N/A';
            switch (service.request.primary_days) {
                case 1: primary = '24H'; break;
                case 2: primary = '48H'; break;
                default:
                    switch (service.request.primary_type) {
                        case 'holter': primary = 'Holter'; break;
                        case 'extended': primary = 'Extended'; break;
                        case 'wifi': primary = 'Event'; break;
                        case 'mct': primary = 'MCT'; break;
                    }
            }
            const pclass = ddocs > 0 ? 'style="color:#05D62E"' : '';
            if (service.request.extended_type) {
                let extended = service.request.extended_type === 'mct' ? 'MCT' : 'Event';
                const ee = ss.add(service.request.primary_days, 'days');
                const eclass = fdocs > 0 ? 'style="color:#05D62E"' : '';
                return now < ee ? `<strong ${pclass}>${primary}</strong> + ${extended}` : `<span ${pclass}>${primary}</span> + <strong ${eclass}>${extended}</strong>`;
            }
            return `<strong ${pclass}>${primary}</strong>`;
        }
        return 'FORM';
    }
}
